import React from 'react'
import CategoryForm from '../CategoryForm'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import rubricSelectors from '../../../../../../store/selectors/rubric.selectors'
import { useAddCategoryToRubricMutation, useFetchRubricsQuery } from '../../../../../../store/apis/rubric.api'
import { openNotificationWithIcon } from '../../../../../../utils/notification.helper'
import { fetchRubricsSelectors } from '../../../../../../store/apis/utils/selectors/rubric.api.selectors'
import { COLORS } from '../../../../../../utils/colors.helper'
import { useAutoFocusFirstInput } from '../../../../../../../hooks/useAutoFocusFirstInput'

const useUnusedColorId = () => {
    const { token } = useParams()
    const editingRubricId = useSelector(rubricSelectors.editingRubricId)
    const { data: rubric } = useFetchRubricsQuery({ token }, {
        selectFromResult: result => fetchRubricsSelectors.byId({ id: editingRubricId }, result),
    })

    const categories = rubric?.categories || []
    return COLORS.findIndex((_, index) =>
        categories.every(category => category.colorId % COLORS.length !== index),
    )
}

const CreateCategoryForm = ({ onSuccess }) => {
    const editingRubricId = useSelector(rubricSelectors.editingRubricId)
    useAutoFocusFirstInput()

    const [createCategory, createCategoryResult] = useAddCategoryToRubricMutation()
    const onSubmit = async values => {
        const response = await createCategory({ 
            rubricId: editingRubricId, 
            ...values,
            type: 1, // Default type
        })
        if ('data' in response) {
            openNotificationWithIcon('success', 'Category created successfully')
            onSuccess()
        }
    }

    const theFirstUnusedColor = useUnusedColorId()

    return (
        <CategoryForm
            onSubmit={onSubmit}
            error={createCategoryResult?.error}
            loading={createCategoryResult?.isLoading}
            actionName='Create'
            initialValues={{
                colorId: theFirstUnusedColor >= 0 ? theFirstUnusedColor : 0,
            }}
        />
    )
}

export default CreateCategoryForm
